import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { Button, Col, Form, Input, InputGroup, FormFeedback, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
// import FormLayout from 'containers/FormLayout';
// import { login } from 'store/auth/actions';
import { AppNavbarBrand } from '@coreui/react';
import logo from 'assets/images/logo/stepapp_logo.png';
import { message, Checkbox, Spin } from 'antd';
var CryptoJS = require("crypto-js");

const mapStateToProps = (state) => {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    return {
        // login: (payload) => {
        //     dispatch(login(payload))
        // }
    }
}

class PrincipalLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mobile: '',
            password: '',
            rememberMechk: false,
            showOtpFlag: false,
            signLoader: false,
        };

        this.login = this.login.bind(this);
        this.onUpdateFormValue = this.onUpdateFormValue.bind(this);

    }

    Loginerror = (errMsg) => {
        // message.error(errMsg);
        const alert = this.props.alert;     
        alert.error(errMsg)
    };

    Loginsuccess = () => {
        message.success('Login Successful !!');
    };

    onUpdateFormValue(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    onRememberChk = (e) => {

        this.setState({
            rememberMechk: e.target.checked
        })
    }

    async login() {
        try {

            let mobile = this.state.mobile;
            let password = this.state.password;
            let rememberMechk = this.state.rememberMechk
            let loginDate = new Date();
            let expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 14);
            console.log(expiryDate);

            let errorMsg = "";

            let usrencrpt = CryptoJS.AES.encrypt(mobile, '12345').toString();
            let passencrpt = CryptoJS.AES.encrypt(password, '12345').toString();

            if (mobile !== '' && password !== '') {

                //HARDCODE FOR SUPERADMIN USER
                if(mobile === 'superadmin' && password === '1111'){
                  // Save user in redux  
                    this.props.login({
                        role: "superadmin",
                        isPace: true,
                        isSuperAdmin: true,
                    });

                    this.props.history.push('/select-school');

                }else{

                    const result = await window.$http.post('login/userlogin', {
                        usermobile: this.state.mobile,
                        otp: this.state.password
                    });
                    // const result = {"status":"success","message":"","data":{"role":"school","user":{"user_id":2952092,"user_name":"BhupeshKV","first_name":"Bhupesh","last_name":"Bhatt","user_email":"kv2kalaikunda@gmail.com","user_mobile":"09953496776"},"school":{"school_id":1828,"school_name":"KV Kalaikunda No.2"},"board":{"board_id":7,"board_name":"CBSE"},"grade":[]}}

                    if (result.status === "success") {
                        if (rememberMechk === true) {
                            localStorage.setItem('usr', usrencrpt);
                            localStorage.setItem('pas', passencrpt);
                            localStorage.setItem('loginDate', loginDate);
                            localStorage.setItem('expiryDate', expiryDate);
                        }
                        localStorage.setItem('login_data', JSON.stringify(result));
    
                        const { user } = result.data;
    
                        // Save user in redux
                        this.props.login({
                            firstName: user.first_name,
                            lastName: user.last_name,
                            role: "school",
                            isPace: true,
                        });
    
                        this.props.history.push('/select-school');
                    } else {
                        errorMsg = "Incorrect Username or Password !!"
                        this.Loginerror(errorMsg);
    
                        this.setState({
                            mobile: '',
                            password: ''
                        })
    
                    }

                }
            } else {
                errorMsg = "Please enter correct username and password !!"
                this.Loginerror(errorMsg)
            }
        } catch (err) {
            console.log({ err });
            window.$utility.showMessage('error', err.message);
        }
    };

    componentDidMount() {
        let expiryDate = localStorage.getItem('expiryDate');

        var result = new Date();
        result.setDate(result.getDate() + 10);
        console.log(result);


        console.log(expiryDate);
        if (expiryDate !== null) {
            let newExpiryDate = new Date(expiryDate)
            console.log(newExpiryDate);

            var todaysdate = new Date();
            var dateMatch = todaysdate.getDate() === newExpiryDate.getDate();
            console.log(dateMatch);
            if (dateMatch === true) {
                localStorage.clear();
            }
        }
    }

    render() {
        const signLoader = this.state.signLoader
        console.log(signLoader);
        return (
<h2>PP</h2>            

        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrincipalLogin);
